import { cn } from "@shared/ui";
import { ReactNode } from "react";

type StepHeadingProps = {
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  // hero is the welcome screen's larger headline and lead.
  size?: "default" | "hero";
};

const StepHeading = ({ title, description, align = "left", size = "default" }: StepHeadingProps) => (
  <div
    className={cn(
      "flex flex-col",
      size === "hero" ? "gap-4" : "gap-3",
      align === "center" && "items-center text-center"
    )}
  >
    <h1 className={cn(size === "hero" ? "text-display-sm" : "text-title", "text-ink text-balance")}>
      {title}
    </h1>
    {description ? (
      <p className={cn(size === "hero" ? "text-lead-lg" : "text-lead", "text-ink-secondary text-pretty")}>
        {description}
      </p>
    ) : null}
  </div>
);

export default StepHeading;
